import React, {useState} from "react"
import {message, Table, Typography} from "antd"
import ClubMemberFindTrackBoundsDetail from "./ClubMemberFindTrackBoundsDetail"
import {getClubMemberTrackBoundDetail} from "../../../../../../../api/clubMemberList"

const ClubMemberFindTrackBounds = ({loading, datasource}) => {
    const columns = [
        {
            title: '时间',
            dataIndex: 'utime',
            key: 'utime',
        },
        {
            title: '订单号',
            dataIndex: 'serial_number',
            key: 'serial_number',
            render: (text) => <Typography.Text copyable>{text}</Typography.Text>,
        },
        {
            title: '期初',
            dataIndex: 'init',
            key: 'init',
            render: (text) => <span>{(text / 100).toFixed(2)}</span>,
        },
        {
            title: '收入',
            dataIndex: 'income',
            key: 'income',
            render: (text) => <span>{(text / 100).toFixed(2)}</span>,
        },
        {
            title: '支出',
            dataIndex: 'outcome',
            key: 'outcome',
            render: (text) => <span>{(text / 100).toFixed(2)}</span>,
        },
        {
            title: '结余',
            dataIndex: 'balance',
            key: 'balance',
            render: (text) => <span>{(text / 100).toFixed(2)}</span>,
        },
    ]

    const [isLoading, setIsLoading] = useState(false)
    const [boundDetailRecord, setBoundDetailRecord] = useState([])

    const fetchBoundsDetail = async (sn) => {
        setIsLoading(true)
        await getClubMemberTrackBoundDetail(sn).then(res => {
            setBoundDetailRecord(res)
        }).catch(err => {
            console.log(err)
            message.error(`获取详情失败：${err.message}`)
        }).finally(() => {
            setIsLoading(false)
        })
    }

    return (
        <div>
            <Table
                rowKey={(record) => record.id}
                loading={loading}
                columns={columns}
                dataSource={datasource}
                expandable={{
                    onExpand: (_, record) => {
                        fetchBoundsDetail(record.serial_number)
                    },
                    expandedRowRender: () => {
                        return (
                            <div>
                                <ClubMemberFindTrackBoundsDetail loading={isLoading} datasource={boundDetailRecord}/>
                            </div>
                        )
                    },
                    rowExpandable: record => record.serial_number !== null,
                }}
            />
        </div>
    )
}

export default ClubMemberFindTrackBounds


// WEBPACK FOOTER //
// ./src/containers/ClubMemberList/component/ClubMemberFind/component/ClubMemberFindTrack/component/ClubMemberFindTrackBounds.js